export enum CountryNameEnum {
    IRELAND = "IRELAND",
    UK = "UK",
    USA = "USA"
}